import qs from 'query-string'
import { rj } from 'react-rocketjump'
import { ajax } from 'rxjs/ajax'
import { map } from 'rxjs/operators'
import rjPlainList from 'react-rocketjump/plugins/plainList'
import { CSRF } from '../../../django'

export const CalendarioOreLavorativeState = rj(rjPlainList(), {
  name: 'Calendario Ore Lavorative',
  mutations: {
    createMultiple: {
      effect: (dateRanges) =>
        ajax({
          method: 'post',
          url: `/api/planner/calendario-ore-lavorative/create-multiple/`,
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': CSRF,
          },
          body: JSON.stringify(dateRanges),
        }).pipe(map((r) => r.response)),
      updater: 'insertItem',
    },
    addDateRange: {
      effect: (dateRange) =>
        ajax({
          method: 'post',
          url: `/api/planner/calendario-ore-lavorative/`,
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': CSRF,
          },
          body: JSON.stringify(dateRange),
        }).pipe(map((r) => r.response)),
      updater: 'insertItem',
    },
    updateDateRange: {
      effect: (dateRange) =>
        ajax({
          method: 'put',
          url: `/api/planner/calendario-ore-lavorative/${dateRange.id}/`,
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': CSRF,
          },
          body: JSON.stringify(dateRange),
        }).pipe(map((r) => r.response)),
      updater: 'updateItem',
    },
    deleteDateRange: rj.mutation.single({
      effect: (dateRange) =>
        ajax({
          method: 'delete',
          url: `/api/planner/calendario-ore-lavorative/${dateRange.id}/`,
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': CSRF,
          },
        }).pipe(map(() => dateRange)),
      updater: 'deleteItem',
    }),
  },
  computed: {
    list: 'getList',
    loading: 'isLoading',
    error: 'getError',
    deleting: (s) => s.mutations.deleteDateRange.pending,
  },
  effect: (params = {}) =>
    ajax.getJSON(
      `/api/planner/calendario-ore-lavorative/?${qs.stringify(params)}`
    ),
})
